import styled from "styled-components";

const Wrapper = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0,0,0,0.04);
  overflow: hidden;
`;

const Title = styled.h3`
  margin-bottom: 24px;
  font-size: 18px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const TableWrapper = styled.div`
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;

  @media (max-width: 768px) {
    display: none;
  }
`;

const Th = styled.th`
  text-align: left;
  padding: 16px;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid ${({ theme }) => theme.colors.border};
  color: ${({ theme }) => theme.colors.textSecondary};
  background: rgba(0,0,0,0.02);

  &:first-child {
    border-top-left-radius: 8px;
  }
  &:last-child {
    border-top-right-radius: 8px;
  }
`;

const Tr = styled.tr`
  transition: background-color 0.2s ease;
  &:hover {
    background-color: rgba(0,0,0,0.015);
  }
`;

const Td = styled.td`
  padding: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textPrimary};
  white-space: nowrap;
`;

const CardList = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`;

const Card = styled.div`
  border: 1px solid rgba(0,0,0,0.08);
  border-radius: 12px;
  padding: 16px;
  background: ${({ theme }) => theme.colors.white || '#fff'};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);
  }
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }

  span:last-child {
    font-weight: 600;
    color: ${({ theme }) => theme.colors.textPrimary};
  }
`;

const Label = styled.span`
  color: ${({ theme }) => theme.colors.textSecondary} !important;
  font-weight: 500 !important;
`;

const Status = styled.span`
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: capitalize;

  background: ${({ type }) => {
    if (type === "paid") return "#DCFCE7";
    if (type === "loan") return "#DBEAFE";
    return "#FEF3C7";
  }};

  color: ${({ type }) => {
    if (type === "paid") return "#166534";
    if (type === "loan") return "#1D4ED8";
    return "#B45309";
  }};
`;

export default function RecentTransactions({ data = [] }) {
  return (
    <Wrapper>
      <Title>Recent Transactions</Title>

      {/* Desktop Table */}
      <TableWrapper>
        <Table>
          <thead>
            <Tr>
              <Th>ID</Th>
              <Th>Customer</Th>
              <Th>Amount</Th>
              <Th>Type</Th>
              <Th>Date</Th>
              <Th>Status</Th>
            </Tr>
          </thead>

          <tbody>
            {data.slice(0, 5).map((item) => (
              <Tr key={item.id}>
                <Td>{item.id}</Td>
                <Td>{item.customer}</Td>
                <Td>{item.amount}</Td>
                <Td>{item.type}</Td>
                <Td>{item.date}</Td>
                <Td>
                  <Status type={item.status}>{item.type}</Status>
                </Td>
              </Tr>
            ))}
          </tbody>
        </Table>
      </TableWrapper>

      {/* Mobile Cards */}
      <CardList>
        {data.map((item) => (
          <Card key={item.id}>
            <Row>
              <Label>ID</Label>
              <span>{item.id}</span>
            </Row>

            <Row>
              <Label>Customer</Label>
              <span>{item.customer}</span>
            </Row>

            <Row>
              <Label>Amount</Label>
              <span>{item.amount}</span>
            </Row>

            <Row>
              <Label>Date</Label>
              <span>{item.date}</span>
            </Row>

            <Row>
              <Label>Status</Label>
              <Status type={item.status}>{item.type}</Status>
            </Row>
          </Card>
        ))}
      </CardList>
    </Wrapper>
  );
}